import { progressAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle(({ withWhiteBackground }) => ({
    track: {
        maxHeight: "8px",
        backgroundColor: withWhiteBackground
            ? "semantic.background.disabled"
            : "semantic.surface.1",
    },
}));
const variants = {
    default: definePartsStyle(({ max, value, isDisabled }) => ({
        filledTrack: {
            minWidth: isDisabled ? 0 : "4px",
            backgroundColor: value === max
                ? "semantic.tag.validationHover"
                : "semantic.interactive.primary",
        },
    })),
    highlight: definePartsStyle(({ max, value, isDisabled }) => ({
        filledTrack: {
            minWidth: isDisabled ? 0 : "4px",
            backgroundColor: value === max
                ? "semantic.tag.validationHover"
                : "semantic.text.highlight",
        },
    })),
};
const ProgressTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: "default",
    },
});
export default ProgressTheme;
//# sourceMappingURL=Progress.default.js.map